export { SingleSelect } from './SingleSelect';
export { SingleSelectModel } from './SingleSelectModel';
import styles from './SingleSelect.module.scss';

export const SingleSelect_styles = styles;
